const countries: {
  [key: string]: string
} = {
  '999': 'global',
  '998': 'schengen',
  '997': 'gcc',

  '117': 'af',
  '009': 'al',
  '231': 'as',
  '134': 'ai',
  '135': 'ag',
  '010': 'ar',
  '201': 'am',
  '136': 'aw',
  '011': 'au',
  '102': 'at',
  '111': 'az',
  '098': 'bs',
  '012': 'bh',
  '013': 'bd',
  '137': 'bb',
  '241': 'by',
  '014': 'be',
  '154': 'bz',
  '015': 'bm',
  '197': 'bt',
  '016': 'bo',
  '209': 'ba',
  '017': 'bw',
  '018': 'br',
  '112': 'bn',
  '019': 'bg',
  '177': 'bf',
  '163': 'bi',
  '020': 'ca',
  '178': 'cv',
  '171': 'cf',
  '022': 'cl',
  '023': 'cn',
  '242': 'cn',
  '194': 'hk',
  '195': 'mo',
  '024': 'co',
  '240': 'cd',
  '173': 'cg',
  '232': 'ck',
  '155': 'cr',
  '139': 'cu',
  '027': 'cz',
  '179': 'ci',
  '028': 'dk',
  '190': 'dj',
  '140': 'dm',
  '141': 'do',
  '003': 'eg',
  '165': 'er',
  '029': 'ee',
  '094': 'et',
  '099': 'ec',
  '204': 'fo',
  '219': 'fj',
  '031': 'fi',
  '032': 'fr',
  '160': 'fr',
  '180': 'gm',
  '202': 'ge',
  '033': 'de',
  '181': 'gh',
  '211': 'gi',
  '097': 'gr',
  '131': 'gl',
  '142': 'gd',
  '143': 'fr',
  '223': 'gu',
  '157': 'gt',
  '182': 'gn',
  '183': 'gw',
  '161': 'gy',
  '144': 'ht',
  '212': 'va',
  '158': 'hn',
  '034': 'hk',
  '035': 'hu',
  '036': 'is',
  '008': 'in',
  '037': 'id',
  '091': 'ir',
  '092': 'iq',
  '095': 'ie',
  '038': 'il',
  '039': 'it',
  '145': 'jm',
  '040': 'jp',
  '042': 'jo',
  '043': 'kz',
  '044': 'ke',
  '225': 'ki',
  '005': 'kw',
  '198': 'la',
  '046': 'lv',
  '192': 'lb',
  '176': 'ls',
  '104': 'lr',
  '105': 'ly',
  '217': 'li',
  '047': 'lt',
  '048': 'lu',
  '213': 'mk',
  '166': 'mg',
  '167': 'mw',
  '049': 'my',
  '184': 'ml',
  '050': 'mt',
  '226': 'mh',
  '146': 'mq',
  '051': 'mu',
  '052': 'mx',
  '203': 'md',
  '218': 'mc',
  '196': 'mn',
  '214': 'me',
  '147': 'ms',
  '053': 'ma',
  '114': 'mz',
  '054': 'na',
  '228': 'nr',
  '101': 'np',
  '055': 'nl',
  '220': 'nc',
  '056': 'nz',
  '159': 'ni',
  '185': 'ne',
  '057': 'ng',
  '234': 'nu',
  '103': 'kp',
  '205': 'gb',
  '229': 'mp',
  '058': 'no',
  '006': 'om',
  '059': 'pk',
  '230': 'pw',
  '100': 'pa',
  '113': 'pg',
  '060': 'py',
  '061': 'pe',
  '062': 'ph',
  '235': 'pn',
  '063': 'pl',
  '096': 'pt',
  '148': 'pr',
  '064': 'ro',
  '065': 'ru',
  '169': 'rw',
  '168': 'fr',
  '174': 'st',
  '186': 'gb',
  '149': 'kn',
  '150': 'lc',
  '215': 'sm',
  '004': 'sa',
  '187': 'sn',
  '170': 'sc',
  '188': 'sl',
  '066': 'sg',
  '067': 'sk',
  '068': 'si',
  '221': 'sb',
  '239': 'so',
  '069': 'za',
  '045': 'kr',
  '001': 'qa',
  '093': 'sd',
  '162': 'sr',
  '072': 'se',
  '090': 'sy',
  '074': 'tw',
  '200': 'tj',
  '075': 'tz',
  '007': 'th',
  '199': 'tl',
  '189': 'tg',
  '237': 'to',
  '152': 'tt',
  '076': 'tn',
  '077': 'tr',
  '132': 'tm',
  '238': 'tv',
  '153': 'us',
  '078': 'ug',
  '079': 'ua',
  '002': 'ae',
  '081': 'gb',
  '082': 'us',
  '083': 'uy',
  '084': 'uz',
  '222': 'vu',
  '085': 've',
  '086': 'vn',
  '207': 'gb',
  '107': 'ye',
  '088': 'zm',
  '070': 'es',
  '109': 'dz',
  '138': 'gb',
  '208': 'ad',
  '021': 'ky',
  '172': 'td',
  '164': 'km',
  '025': 'hr',
  '156': 'sv',
  '115': 'gq',
  '233': 'pf',
  '227': 'fm',
  '151': 'vc',
  '236': 'ws',
  '216': 'rs',
  '071': 'lk',
  '073': 'ch',
  '243': 'kh',
  '026': 'cy',
  '224': 'us',
  '041': 'je',
  '110': 'ks',
  '106': 'mv',
  '193': 'ps',
  '206': 'gb',
  '089': 'zw',
  '246': 'mm',
}

export default countries
